export default function usrGoogleSignIn(data) {

  this.load();
  this.rest.post('googleSignIn',{},ret=>{
    this.unLoad();
    if (ret.state){
      window.open(ret.redirect_url,'_blank');
    }
  })
}